export default "__VITE_ASSET__C1D3qLJh__"